import React from 'react';

import FormContainer from '../../../FormContainer';

import useDetailsForm from '../../../../../forms/loan/details';

export default function Details({ loan }) {
  const form = useDetailsForm(() => {}, loan);

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <FormContainer form={form} noSubmit noBillComId />
    </div>
  );
}
